// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".el-empty[data-v-269fb71a]{padding:0!important}.el-empty[data-v-269fb71a] .el-empty__image{display:none}.Table[data-v-269fb71a] .el-table__cell .cell{white-space:pre-wrap!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
